<template>
  <a @click="scrollTop" v-show="visible" class="bottom-right">
    <i class="fas fa-angle-up"></i>
  </a>
</template>

<script>
export default {
  name: "ScrollToTop",
  data() {
    return {
      visible: false
    }
  },
  methods: {
    scrollTop: function () {
      this.intervalId = setInterval(() => {
        if (window.pageYOffset === 0) {
          clearInterval(this.intervalId)
        }
        window.scroll(0, window.pageYOffset - 50)
      }, 20)
    },
    scrollListener: function (e) {
      this.visible = window.scrollY > 100
    }
  },
  mounted: function () {
    window.addEventListener('scroll', this.scrollListener)
  },
  beforeDestroy: function () {
    window.removeEventListener('scroll', this.scrollListener)
  }
}
</script>

<style lang="scss" scoped>
.bottom-right {
  position: fixed;
  bottom: 20px;
  right: 20px;
  cursor: pointer;
  width: 2.75rem;
  height: 2.75rem;
  text-align: center;
  background: fade-out(#343a40, .5);
  line-height: 46px;
  border-radius: 5px;

  &:hover {
    background: #343a40;
  }

  i {
    color: #FFFFFF;
    font-weight: 800;
  }

}
</style>
